export const currencies = [
  { country: "Afghanistan", currency: "Afghan Afghani", code: "AFN" },
  { country: "Albania", currency: "Albanian Lek", code: "ALL" },
  { country: "Algeria", currency: "Algerian Dinar", code: "DZD" },
  { country: "Andorra", currency: "Euro", code: "EUR" },
  { country: "Angola", currency: "Angolan Kwanza", code: "AOA" },
  {
    country: "Antigua and Barbuda",
    currency: "East Caribbean Dollar",
    code: "XCD",
  },
  { country: "Argentina", currency: "Argentine Peso", code: "ARS" },
  { country: "Armenia", currency: "Armenian Dram", code: "AMD" },
  { country: "Australia", currency: "Australian Dollar", code: "AUD" },
  { country: "Austria", currency: "Euro", code: "EUR" },
  { country: "Azerbaijan", currency: "Azerbaijani Manat", code: "AZN" },
  { country: "Bahamas", currency: "Bahamian Dollar", code: "BSD" },
  { country: "Bahrain", currency: "Bahraini Dinar", code: "BHD" },
  { country: "Bangladesh", currency: "Bangladeshi Taka", code: "BDT" },
  { country: "Barbados", currency: "Barbadian Dollar", code: "BBD" },
  { country: "Belarus", currency: "Belarusian Ruble", code: "BYN" },
  { country: "Belgium", currency: "Euro", code: "EUR" },
  { country: "Belize", currency: "Belize Dollar", code: "BZD" },
  { country: "Benin", currency: "West African CFA Franc", code: "XOF" },
  { country: "Bhutan", currency: "Bhutanese Ngultrum", code: "BTN" },
  { country: "Bolivia", currency: "Bolivian Boliviano", code: "BOB" },
  {
    country: "Bosnia and Herzegovina",
    currency: "Bosnia-Herzegovina Convertible Mark",
    code: "BAM",
  },
  { country: "Botswana", currency: "Botswana Pula", code: "BWP" },
  { country: "Brazil", currency: "Brazilian Real", code: "BRL" },
  { country: "Brunei", currency: "Brunei Dollar", code: "BND" },
  { country: "Bulgaria", currency: "Bulgarian Lev", code: "BGN" },
  { country: "Burkina Faso", currency: "West African CFA Franc", code: "XOF" },
  { country: "Burundi", currency: "Burundian Franc", code: "BIF" },
  { country: "Cabo Verde", currency: "Cape Verdean Escudo", code: "CVE" },
  { country: "Cambodia", currency: "Cambodian Riel", code: "KHR" },
  { country: "Cameroon", currency: "Central African CFA Franc", code: "XAF" },
  { country: "Canada", currency: "Canadian Dollar", code: "CAD" },
  {
    country: "Central African Republic",
    currency: "Central African CFA Franc",
    code: "XAF",
  },
  { country: "Chad", currency: "Central African CFA Franc", code: "XAF" },
  { country: "Chile", currency: "Chilean Peso", code: "CLP" },
  { country: "China", currency: "Chinese Yuan", code: "CNY" },
  { country: "Colombia", currency: "Colombian Peso", code: "COP" },
  { country: "Comoros", currency: "Comorian Franc", code: "KMF" },
  {
    country: "Congo (Congo-Brazzaville)",
    currency: "Central African CFA Franc",
    code: "XAF",
  },
  { country: "Congo (DRC)", currency: "Congolese Franc", code: "CDF" },
  { country: "Costa Rica", currency: "Costa Rican Colón", code: "CRC" },
  { country: "Croatia", currency: "Euro", code: "EUR" },
  { country: "Cuba", currency: "Cuban Peso", code: "CUP" },
  { country: "Cyprus", currency: "Euro", code: "EUR" },
  { country: "Czech Republic", currency: "Czech Koruna", code: "CZK" },
  { country: "Denmark", currency: "Danish Krone", code: "DKK" },
  { country: "Djibouti", currency: "Djiboutian Franc", code: "DJF" },
  { country: "Dominica", currency: "East Caribbean Dollar", code: "XCD" },
  { country: "Dominican Republic", currency: "Dominican Peso", code: "DOP" },
  { country: "Ecuador", currency: "United States Dollar", code: "USD" },
  { country: "Egypt", currency: "Egyptian Pound", code: "EGP" },
  { country: "El Salvador", currency: "United States Dollar", code: "USD" },
  {
    country: "Equatorial Guinea",
    currency: "Central African CFA Franc",
    code: "XAF",
  },
  { country: "Eritrea", currency: "Eritrean Nakfa", code: "ERN" },
  { country: "Estonia", currency: "Euro", code: "EUR" },
  { country: "Eswatini", currency: "Swazi Lilangeni", code: "SZL" },
  { country: "Ethiopia", currency: "Ethiopian Birr", code: "ETB" },
  { country: "Fiji", currency: "Fijian Dollar", code: "FJD" },
  { country: "Finland", currency: "Euro", code: "EUR" },
  { country: "France", currency: "Euro", code: "EUR" },
  { country: "Gabon", currency: "Central African CFA Franc", code: "XAF" },
  { country: "Gambia", currency: "Gambian Dalasi", code: "GMD" },
  { country: "Georgia", currency: "Georgian Lari", code: "GEL" },
  { country: "Germany", currency: "Euro", code: "EUR" },
  { country: "Ghana", currency: "Ghanaian Cedi", code: "GHS" },
  { country: "Greece", currency: "Euro", code: "EUR" },
  { country: "Grenada", currency: "East Caribbean Dollar", code: "XCD" },
  { country: "Guatemala", currency: "Guatemalan Quetzal", code: "GTQ" },
  { country: "Guinea", currency: "Guinean Franc", code: "GNF" },
  { country: "Guinea-Bissau", currency: "West African CFA Franc", code: "XOF" },
  { country: "Guyana", currency: "Guyanese Dollar", code: "GYD" },
  { country: "Haiti", currency: "Haitian Gourde", code: "HTG" },
  { country: "Honduras", currency: "Honduran Lempira", code: "HNL" },
  { country: "Hungary", currency: "Hungarian Forint", code: "HUF" },
  { country: "Iceland", currency: "Icelandic Króna", code: "ISK" },
  { country: "India", currency: "Indian Rupee", code: "INR" },
  { country: "Indonesia", currency: "Indonesian Rupiah", code: "IDR" },
  { country: "Iran", currency: "Iranian Rial", code: "IRR" },
  { country: "Iraq", currency: "Iraqi Dinar", code: "IQD" },
  { country: "Ireland", currency: "Euro", code: "EUR" },
  { country: "Israel", currency: "Israeli New Shekel", code: "ILS" },
  { country: "Italy", currency: "Euro", code: "EUR" },
  { country: "Jamaica", currency: "Jamaican Dollar", code: "JMD" },
  { country: "Japan", currency: "Japanese Yen", code: "JPY" },
  { country: "Jordan", currency: "Jordanian Dinar", code: "JOD" },
  { country: "Kazakhstan", currency: "Kazakhstani Tenge", code: "KZT" },
  { country: "Kenya", currency: "Kenyan Shilling", code: "KES" },
  { country: "Kiribati", currency: "Australian Dollar", code: "AUD" },
  { country: "Kuwait", currency: "Kuwaiti Dinar", code: "KWD" },
  { country: "Kyrgyzstan", currency: "Kyrgyzstani Som", code: "KGS" },
  { country: "Laos", currency: "Lao Kip", code: "LAK" },
  { country: "Latvia", currency: "Euro", code: "EUR" },
  { country: "Lebanon", currency: "Lebanese Pound", code: "LBP" },
  { country: "Lesotho", currency: "Lesotho Loti", code: "LSL" },
  { country: "Liberia", currency: "Liberian Dollar", code: "LRD" },
  { country: "Libya", currency: "Libyan Dinar", code: "LYD" },
  { country: "Liechtenstein", currency: "Swiss Franc", code: "CHF" },
  { country: "Lithuania", currency: "Euro", code: "EUR" },
  { country: "Luxembourg", currency: "Euro", code: "EUR" },
  { country: "Madagascar", currency: "Malagasy Ariary", code: "MGA" },
  { country: "Malawi", currency: "Malawian Kwacha", code: "MWK" },
  { country: "Malaysia", currency: "Malaysian Ringgit", code: "MYR" },
  { country: "Maldives", currency: "Maldivian Rufiyaa", code: "MVR" },
  { country: "Mali", currency: "West African CFA Franc", code: "XOF" },
  { country: "Malta", currency: "Euro", code: "EUR" },
  {
    country: "Marshall Islands",
    currency: "United States Dollar",
    code: "USD",
  },
  { country: "Mauritania", currency: "Mauritanian Ouguiya", code: "MRU" },
  { country: "Mauritius", currency: "Mauritian Rupee", code: "MUR" },
  { country: "Mexico", currency: "Mexican Peso", code: "MXN" },
  { country: "Micronesia", currency: "United States Dollar", code: "USD" },
  { country: "Moldova", currency: "Moldovan Leu", code: "MDL" },
  { country: "Monaco", currency: "Euro", code: "EUR" },
  { country: "Mongolia", currency: "Mongolian Tögrög", code: "MNT" },
  { country: "Montenegro", currency: "Euro", code: "EUR" },
  { country: "Morocco", currency: "Moroccan Dirham", code: "MAD" },
  { country: "Mozambique", currency: "Mozambican Metical", code: "MZN" },
  { country: "Myanmar (Burma)", currency: "Burmese Kyat", code: "MMK" },
  { country: "Namibia", currency: "Namibian Dollar", code: "NAD" },
  { country: "Nauru", currency: "Australian Dollar", code: "AUD" },
  { country: "Nepal", currency: "Nepalese Rupee", code: "NPR" },
  { country: "Netherlands", currency: "Euro", code: "EUR" },
  { country: "New Zealand", currency: "New Zealand Dollar", code: "NZD" },
  { country: "Nicaragua", currency: "Nicaraguan Córdoba", code: "NIO" },
  { country: "Niger", currency: "West African CFA Franc", code: "XOF" },
  { country: "Nigeria", currency: "Nigerian Naira", code: "NGN" },
  { country: "North Korea", currency: "North Korean Won", code: "KPW" },
  { country: "North Macedonia", currency: "Macedonian Denar", code: "MKD" },
  { country: "Norway", currency: "Norwegian Krone", code: "NOK" },
  { country: "Oman", currency: "Omani Rial", code: "OMR" },
  { country: "Pakistan", currency: "Pakistani Rupee", code: "PKR" },
  { country: "Palau", currency: "United States Dollar", code: "USD" },
  { country: "Palestine", currency: "Israeli New Shekel", code: "ILS" },
  { country: "Panama", currency: "Panamanian Balboa", code: "PAB" },
  {
    country: "Papua New Guinea",
    currency: "Papua New Guinean Kina",
    code: "PGK",
  },
  { country: "Paraguay", currency: "Paraguayan Guaraní", code: "PYG" },
  { country: "Peru", currency: "Peruvian Sol", code: "PEN" },
  { country: "Philippines", currency: "Philippine Peso", code: "PHP" },
  { country: "Poland", currency: "Polish Złoty", code: "PLN" },
  { country: "Portugal", currency: "Euro", code: "EUR" },
  { country: "Qatar", currency: "Qatari Riyal", code: "QAR" },
  { country: "Romania", currency: "Romanian Leu", code: "RON" },
  { country: "Russia", currency: "Russian Ruble", code: "RUB" },
  { country: "Rwanda", currency: "Rwandan Franc", code: "RWF" },
  {
    country: "Saint Kitts and Nevis",
    currency: "East Caribbean Dollar",
    code: "XCD",
  },
  { country: "Saint Lucia", currency: "East Caribbean Dollar", code: "XCD" },
  {
    country: "Saint Vincent and the Grenadines",
    currency: "East Caribbean Dollar",
    code: "XCD",
  },
  { country: "Samoa", currency: "Samoan Tālā", code: "WST" },
  { country: "San Marino", currency: "Euro", code: "EUR" },
  {
    country: "Sao Tome and Principe",
    currency: "São Tomé and Príncipe Dobra",
    code: "STN",
  },
  { country: "Saudi Arabia", currency: "Saudi Riyal", code: "SAR" },
  { country: "Senegal", currency: "West African CFA Franc", code: "XOF" },
  { country: "Serbia", currency: "Serbian Dinar", code: "RSD" },
  { country: "Seychelles", currency: "Seychellois Rupee", code: "SCR" },
  { country: "Sierra Leone", currency: "Sierra Leonean Leone", code: "SLE" },
  { country: "Singapore", currency: "Singapore Dollar", code: "SGD" },
  { country: "Slovakia", currency: "Euro", code: "EUR" },
  { country: "Slovenia", currency: "Euro", code: "EUR" },
  {
    country: "Solomon Islands",
    currency: "Solomon Islands Dollar",
    code: "SBD",
  },
  { country: "Somalia", currency: "Somali Shilling", code: "SOS" },
  { country: "South Africa", currency: "South African Rand", code: "ZAR" },
  { country: "South Korea", currency: "South Korean Won", code: "KRW" },
  { country: "South Sudan", currency: "South Sudanese Pound", code: "SSP" },
  { country: "Spain", currency: "Euro", code: "EUR" },
  { country: "Sri Lanka", currency: "Sri Lankan Rupee", code: "LKR" },
  { country: "Sudan", currency: "Sudanese Pound", code: "SDG" },
  { country: "Suriname", currency: "Surinamese Dollar", code: "SRD" },
  { country: "Sweden", currency: "Swedish Krona", code: "SEK" },
  { country: "Switzerland", currency: "Swiss Franc", code: "CHF" },
  { country: "Syria", currency: "Syrian Pound", code: "SYP" },
  { country: "Taiwan", currency: "New Taiwan Dollar", code: "TWD" },
  { country: "Tajikistan", currency: "Tajikistani Somoni", code: "TJS" },
  { country: "Tanzania", currency: "Tanzanian Shilling", code: "TZS" },
  { country: "Thailand", currency: "Thai Baht", code: "THB" },
  { country: "Timor-Leste", currency: "United States Dollar", code: "USD" },
  { country: "Togo", currency: "West African CFA Franc", code: "XOF" },
  { country: "Tonga", currency: "Tongan Paʻanga", code: "TOP" },
  {
    country: "Trinidad and Tobago",
    currency: "Trinidad and Tobago Dollar",
    code: "TTD",
  },
  { country: "Tunisia", currency: "Tunisian Dinar", code: "TND" },
  { country: "Turkey", currency: "Turkish Lira", code: "TRY" },
  { country: "Turkmenistan", currency: "Turkmenistani Manat", code: "TMT" },
  { country: "Tuvalu", currency: "Australian Dollar", code: "AUD" },
  { country: "Uganda", currency: "Ugandan Shilling", code: "UGX" },
  { country: "Ukraine", currency: "Ukrainian Hryvnia", code: "UAH" },
  {
    country: "United Arab Emirates",
    currency: "United Arab Emirates Dirham",
    code: "AED",
  },
  {
    country: "United Kingdom",
    currency: "British Pound Sterling",
    code: "GBP",
  },
  { country: "United States", currency: "United States Dollar", code: "USD" },
  { country: "Uruguay", currency: "Uruguayan Peso", code: "UYU" },
  { country: "Uzbekistan", currency: "Uzbekistani Som", code: "UZS" },
  { country: "Vanuatu", currency: "Vanuatu Vatu", code: "VUV" },
  { country: "Vatican City", currency: "Euro", code: "EUR" },
  { country: "Venezuela", currency: "Venezuelan Bolívar", code: "VES" },
  { country: "Vietnam", currency: "Vietnamese Đồng", code: "VND" },
  { country: "Yemen", currency: "Yemeni Rial", code: "YER" },
  { country: "Zambia", currency: "Zambian Kwacha", code: "ZMW" },
  { country: "Zimbabwe", currency: "Zimbabwean Dollar", code: "ZWL" },
]
